import { render, staticRenderFns } from "./GraphDetail52.vue?vue&type=template&id=1cec6fda&scoped=true"
import script from "./GraphDetail52.vue?vue&type=script&lang=js"
export * from "./GraphDetail52.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec6fda",
  null
  
)

export default component.exports